<template lang="pug">
  div.wrap-visualization-item-emort-text.howahowaup-infinite
    span.fz16 {{targetEmoji}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/animation.scss";
// @import "@/scss/doodleAnimation.scss";

.wrap-visualization-item-emort-text {
  .wrap-emort {
    
  }
}

.howahowaup-infinite {
  animation: howahowaup 2400ms linear infinite;
  // animation: howahowaup 2400ms linear 0s 1;
}
@keyframes howahowaup {
  0%   { transform: scale(1.0) translate(0%, 0%); opacity: 0.0; }
  25%   { transform: scale(1.4) translate(70%, -25%); opacity: 1.0; }
  50%   { transform: scale(1.6) translate(-70%, -50%); opacity: 1.0; }
  75%   { transform: scale(1.8) translate(90%, -75%); opacity: 1.0; }
  100% { transform: scale(2.0) translate(-90%, -100%); opacity: 0.0; }
}
</style>

<script>
import { emortSounds } from '@/components/utils/sounds'

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  computed: {
    targetEmoji () {
      const emort = emortSounds.filter(e => e.id === this.message.type)[0]
      return emort ? emort.emoji : ''
    }
  },
  created () {
    
  }
}
</script>
